import { FC } from 'react'
import type { FormInstance } from 'antd/es/form/Form'
import FormItem from 'antd/es/form/FormItem'
import { RequestCreateLeadPaymentLink } from '@/api/types/crm/crm.types'
import LessonCountLinkFields from '../LessonCountLinkFields/LessonCountLinkFields'
import CourseLinkTeacherSelect from './CourseLinkTeacherSelect'
import CreateLinkSectionTitle from '../../CreateLinkSectionTitle'
import CreateLinkNumberInput, {
  createLinkNumberRuleTransform,
} from '../../CreateLinkNumberInput'
import spclasses from '../../../SetCourseClassDirectionModal/purchase.module.css'
import sclasses from '../../../SetCourseClassDirectionModal/index.module.css'
import { CREATE_LINK_BLOCK_TARIFF_TYPES } from '../../tariffTypes'
import { getCreateLinkBlockTariffTypesHint } from '../../createLinkBlockInfoContent'

type FieldType = Omit<RequestCreateLeadPaymentLink, 'lead_funnel_id'>

type IndividualLessonLinkFieldsProps = {
  form: FormInstance
  courseId?: number | null
}

/**
 * UI-блок CRM-ссылки для hour / minute:
 * длительность, цена занятия, педагог, кол-во занятий (value + is_value_fixed).
 */
const IndividualLessonLinkFields: FC<IndividualLessonLinkFieldsProps> = ({
  form,
  courseId,
}) => {
  return (
    <>
      <CreateLinkSectionTitle
        title="Параметры занятия"
        infoText={getCreateLinkBlockTariffTypesHint(
          CREATE_LINK_BLOCK_TARIFF_TYPES.individualLesson,
        )}
      />
      <div className={sclasses.inputWithLabel}>
        <FormItem<FieldType>
          name="lesson_duration"
          rules={[
            {
              required: true,
              message: 'Укажите длительность занятия',
            },
            {
              type: 'number',
              min: 1,
              max: 1440,
              message: 'Длительность: от 1 до 1440 минут',
              transform: createLinkNumberRuleTransform,
            },
          ]}
          noStyle
        >
          <CreateLinkNumberInput
            className={spclasses.input}
            title="Длительность занятия (мин.)"
            integer
            min={1}
            max={1440}
            placeholder={60}
          />
        </FormItem>
      </div>

      <div className={sclasses.inputWithLabel}>
        <FormItem<FieldType>
          name="first_price"
          rules={[
            {
              required: true,
              message: 'Укажите цену занятия',
            },
            {
              type: 'number',
              min: 0,
              message: 'Цена не может быть отрицательной',
              transform: createLinkNumberRuleTransform,
            },
          ]}
          noStyle
        >
          <CreateLinkNumberInput
            className={spclasses.input}
            title="Цена одного занятия (₽)"
            min={0}
            placeholder={0}
          />
        </FormItem>
      </div>

      <CourseLinkTeacherSelect form={form} courseId={courseId} />

      <LessonCountLinkFields form={form} />
    </>
  )
}

export default IndividualLessonLinkFields
